import React, { useEffect, useState, useRef } from "react";
import "../../../Pages/Tv/Iplbattle/iplbattle.css";

import useUserInfo from "../../../Hooks/useUserInfo";
import { logPageView } from "../../../components/analytics";
import { userGameRewards } from "../../../apis/user";
import { useAudio } from "../../../Providers/AudioProvider";
import task from "../Task";


const CricketTask = (props) => {
    const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();
  const [score,setScore] =useState(0);
  const [ballCount,setBallCount]=useState(0);
  const [gameActive,setIsGameActive] = useState(false);

  
  const playClick = useAudio();
const [isLoading,setIsLoading]=useState(false);
  const IPL_TEAMS = [
    "PUNJAB",
    "HYDERABAD",
    "LUCKNOW",
    "GUJARAT",
    "KOLKATA",
    "DELHI",
    "BENGALURU",
    "CHENNAI",
    "RAJASTHAN",
    "MUMBAI",
  ];

  const CurrentData = watchScreen?.currentBattleDetails;
  const CurrentMatch = watchScreen?.current_battle;
  const CurrentTeams = CurrentMatch?.teams;

  // let s_oGame = new CGame
  // const currentScore = s_oGame.getScore();
  // console.log("Current Score:", currentScore);

  useEffect(() => {
    logPageView("Cricket ", "game Cricket");
  }, []);

  const getTeamIndex = (teamName) => {
    return IPL_TEAMS.indexOf(teamName);
  };

  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: task,
      currentComponentText: "task",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  const apiCallMadeRef = useRef(false);
  const [apiCallMade, setApiCallMade] = useState(false);
  const currentGameSessionRef = useRef(null); 
  
  const handleApiResponse = async (points) => {
    // Use ref for immediate synchronous check
    if (apiCallMadeRef.current) {
      console.log("API call already made, skipping duplicate call for session:", currentGameSessionRef.current);
      return;
    }
    
    console.log("Starting API call for cricket game with points:", points, "session:", currentGameSessionRef.current);
    apiCallMadeRef.current = true; // Set ref immediately
    setApiCallMade(true); // Also set state for UI updates
    
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    setIsLoading(true);
    
    try {
      const apiData = {
        gamePoints: points,
        gameType: "cricket",
      };
      console.log("Making API call with data:", apiData);
      const res = await userGameRewards(apiData);
      
      if (res) {
        console.log("API call successful:", res);
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        updatewatchScreenInfo((prev) => ({
          ...prev,
          LoginMessage: res?.message,
        }));
        setIsLoading(false);
      } else {
        console.log("API call returned no response");
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        setIsLoading(false);
      }
    } catch (error) {
      console.error("API call failed:", error);
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
      setIsLoading(false);
      // Reset both ref and state on error so we can try again
      apiCallMadeRef.current = false;
      setApiCallMade(false);
    }
  };
  useEffect(() => {
    // Listen for messages from the iframe
    const handleMessage = (event) => {
      // Verify the origin of the message for security
      if (event.origin !== window.location.origin) return;

      const { type, data } = event.data;
      console.log("Received message from iframe:", type, data);

      switch (type) {
        case "SCORE_UPDATE":
          setScore(data?.score);
          setBallCount(data?.ball);
          setIsGameActive(true);
          // Reset API call flag when new game starts (ball count resets to 0)
          if (data?.ball === 0) {
            console.log("Game started, resetting API call flag");
            apiCallMadeRef.current = false;
            setApiCallMade(false);
          }
          break;
        case "GAME_OVER":
          console.log("Game over received, score:", data?.score);
          setBallCount(data.ball);
          setIsGameActive(true);
          
          // Create a unique session ID for this game over event
          const gameOverSessionId = `game_over_${Date.now()}_${data?.score}`;
          
          // Only call API if not already called (use ref for immediate check)
          if (!apiCallMadeRef.current) {
            console.log("Making API call for game over session:", gameOverSessionId);
            currentGameSessionRef.current = gameOverSessionId;
            handleApiResponse(data?.score);
          } else {
            console.log("API call already made for this game, skipping session:", gameOverSessionId);
          }
          break;
        case "GAME_START":
          console.log("Game start received");
          setIsGameActive(true);
          // Reset API call flag when game starts
          apiCallMadeRef.current = false;
          setApiCallMade(false);
          break;
        case "GAME_PAUSE":
          setIsGameActive(true);
          break;
        default:
          console.log("Unknown message type:", type);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []); // Remove dependencies to prevent multiple event listener registrations

  return (
    <>
    <div
      className="menupointer"
      style={{
        height: "100%",
        width: "100%",
        pointerEvents: "fill",
        backgroundColor: "#000",
        zIndex: "2",
      }}
    >
      <header style={{ position: "relative", width: "100%" }}>
    
            <div class="score-container1">
              <img
                onClick={() => {
                  if (!isLoading)
                  toogleMenu(task, "task");
                }}
                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
                className="cancel-imgflappy"
                style={{ cursor: "pointer",width:"25px" }}
              />
              {/* <div id="currentScore">Score : 0</div> */}
            </div>
          </header>
      <div className="row">
        <div className="col-12">
          <iframe
            src={"/game/index.html?playerTeam=3&opponentTeam=7"}
            style={{
              // width: "100%",
              height: "95vh",
              border: "none",
              pointerEvents: "fill",
              width: "100vw",
              // position: "fixed",
              bottom: "0%",
              overflow: "hidden",
            }}
            title="Cricket Game"
          />
        </div>
      </div>
    </div>
    <style>
 {`
 .score-container1
 {
  display: flex;
  justify-content: space-between;
  padding: 8px 6px;
  background: #161616b0;
  color: #fff;
 }
 `}
    </style>
    </>
  );
};
export default CricketTask;

